import { SvgIcon } from '@bob/library'
import { mapTeacherHubNavigation } from '@websrc/DataMappers/mapTeacherHubNavigation'
import clsx from 'clsx'
import { box, listItem, styles } from 'leds'
import React, { FC } from 'react'

export type SidebarItemLabelProps = {
  item: ReturnType<typeof mapTeacherHubNavigation>
  selected: boolean
}

export const SidebarItemLabel: FC<SidebarItemLabelProps> = ({ item, selected }) => (
  <div
    className={clsx(
      styles({ paddingX: 8 }),
      listItem({
        level: 'first',
        background: selected ? 'whiteBlue' : 'grey1',
      })
    )}
  >
    <div className={box({ type: 'icon' })}>
      <SvgIcon color={'black'} name={item.icon} size={24} title={item.label} />
    </div>
    <div className={styles({ display: { screenM: 'block' } })}>
      <label data-testid={`item-selected-${selected}`}>{item.label}</label>
    </div>
  </div>
)
